import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgStarter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m8 16 10-8 10 8v16H8z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M16 22h-6v10h6zM28 24a8 8 0 1 0 0-16 8 8 0 0 0 0 16"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M18.5 18a7.5 7.5 0 0 0 15 0h1a8.5 8.5 0 1 1-17 0zM9.5 23.11H12v1h-1.5v5.5h-1z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      d="m27 14.71-1.9 1.14L24 14.1l3.21-2.56h2.29v8.92H27z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgStarter);

export default ForwardRef;
